export default function AttachPreparationItemReportController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Report Added';
  vm.isExpanded = false;
  vm.loading = false;
  vm.permissions = null;

  vm.canDownloadReport = userService.getUserPermission('displayDOCDownloadReportLink');
  vm.canEditReport = userService.getUserPermission('displayDOCEditReportLink');
  vm.canDeleteReport = userService.getUserPermission('displayDOCDeleteReportLink');

  vm.handleAttachReport = _handleAttachReport;
  vm.handleDownloadReport = _handleDownloadReport;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    userService.getUserPermissionSet('auditTrail')
      .then((permissions) => {
        vm.permissions = permissions;
      });
  }

  function _handleAttachReport() {
    const dfdSave = $q.defer();
    loaderService.showViewLoader = true;

    if (vm.report.attached) {
      amDataService.attachPreparationItemReport(vm.preparationItemId, vm.report.reportInstanceId)
        .then((response) => {
          if (!response.data.preparationItemReportInstanceId) {
            alerts.error('Error occurred while attaching the Report.');
            loaderService.showViewLoader = false;
            dfdSave.reject();
          } else {
            alerts.success(`Report ${vm.report.reportName} has been attached successfully.`);
            vm.report.preparationItemReportInstanceId = response.data.preparationItemReportInstanceId;
            $rootScope.$broadcast('refreshAMPreparationItemReports', { preparationItemId: vm.preparationItemId });
            loaderService.showViewLoader = false;
            dfdSave.resolve();
          }
        });
    } else {
      amDataService.detachPreparationItemReport(vm.report.preparationItemReportInstanceId)
        .then(() => {
          alerts.success(`Report ${vm.report.reportName} has been detached successfully.`);
          vm.report.preparationItemReportId = null;
          $rootScope.$broadcast('refreshAMPreparationItemReports', { preparationItemId: vm.preparationItemId });
          dfdSave.resolve();
        })
        .catch(() => {
          alerts.error('Error occurred while detaching the Report.');
          dfdSave.reject();
        })
        .finally(() => {
          loaderService.showViewLoader = false;
        });
    }
  }


  function _handleDownloadReport() {
    /*
    var $ifrmDownloadFile = angular.element('#ifrmDownloadFile');
    var $frmDownloadFile = angular.element(
    '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo($ifrmDownloadFile);
    $frmDownloadFile.attr('action', paths.handlerDirectory + 'AM/LargeFileHandler.ashx');
    $frmDownloadFile.append('<input type="hidden" name="auditPackageId" value="' + vm.auditPackageId + '" />');
    $frmDownloadFile.submit();
    */
  }
}

AttachPreparationItemReportController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService'
];
